module.exports = __webpack_public_path__ + "img/nowork.f37ae71f.gif";